(function (Translator) {
    // lt
    Translator.add("sunday", "Sekmadienis", "PayseraMapBundle", "lt");
    Translator.add("monday", "Pirmadienis", "PayseraMapBundle", "lt");
    Translator.add("tuesday", "Antradienis", "PayseraMapBundle", "lt");
    Translator.add("wednesday", "Tre\u010diadienis", "PayseraMapBundle", "lt");
    Translator.add("thursday", "Ketvirtadienis", "PayseraMapBundle", "lt");
    Translator.add("friday", "Penktadienis", "PayseraMapBundle", "lt");
    Translator.add("saturday", "\u0160e\u0161tadienis", "PayseraMapBundle", "lt");
    Translator.add("address", "Adresas:", "PayseraMapBundle", "lt");
    Translator.add("service.cash_in", "Gryn\u0173j\u0173 \u012fne\u0161imas", "PayseraMapBundle", "lt");
    Translator.add("service.cash_out", "Gryn\u0173j\u0173 i\u0161\u0117mimas", "PayseraMapBundle", "lt");
    Translator.add("service.identification", "Identifikacijos atlikimas", "PayseraMapBundle", "lt");
    Translator.add("service.pay", "\u012emokos", "PayseraMapBundle", "lt");
    Translator.add("services", "Paslaugos:", "PayseraMapBundle", "lt");
    Translator.add("working_hours", "Darbo laikas:", "PayseraMapBundle", "lt");
    Translator.add("search_placeholder", "\u012eveskite fragment\u0105", "PayseraMapBundle", "lt");
    Translator.add("no_results", "Rezultat\u0173 nerasta", "PayseraMapBundle", "lt");
})(Translator);
